/* eslint-disable react/no-array-index-key */
/* eslint-disable */
/* eslint-disable react/jsx-key */
/* eslint-disable no-nested-ternary */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Link, useNavigate } from 'react-router-dom';
import {
  Autocomplete,
  Button,
  Grid,
  InputAdornment,
  IconButton,
  Chip,
  Stack,
  Typography,
  Card,
  CardContent,
  TextField,
  Tooltip
} from '@mui/material';
import { LoopOutlined, ContentCopyOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import dateFormat from 'dateformat';
import DatePicker from 'react-datepicker';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import 'react-datepicker/dist/react-datepicker.css';
import LoadingSkeleton from '../../utils/LoadingSkeleton';
import NoRowsOverlay from '../../utils/NoRowOverlay';
import ConfirmModal from './confirm_modal';
import PaymentAction from '../../store/actions/PaymentAction';
import CopyInput from '../../components/CopyInput';
import useHasPermission from '../../utils/useHasPermission';
import { paymentRequest, show, store, update, destroy } from '../../utils/constants';

function QuickSearchToolbar() {
  return (
    <Box
      className="tableTopWrap page__title"
      sx={{
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 3
      }}
    >
      <Stack direction="row" sx={{ ml: 'auto' }} spacing={2} className="MuiDataGrid-Search">
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput) => searchInput.split(',').map((value) => value.trim())}
          quickFilterFormatter={(quickFilterValues) => quickFilterValues.join(', ')}
          debounceMs={800} // time before applying the new quick filter value
          variant="outlined"
          size="small"
          sx={{ pb: 0, maxWidth: '275px' }}
        />
        {useHasPermission(paymentRequest, store) && (
          <Button
            className="button_primary"
            variant="contained"
            size="small"
            color="secondary"
            component={Link}
            to="/payment-request/add"
          >
            Add Payment Request
          </Button>
        )}
      </Stack>
    </Box>
  );
}

export default function PaymentRequestList() {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });

  const [sortInfo, setSortInfo] = useState({
    sortField: '',
    sort: ''
  });
  const navigate = useNavigate();
  // const [editOpen, setEditOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalStatus, seModalStatus] = useState({ itemID: '', status: '' });
  const [rowCountState, setRowCountState] = useState(0);
  const [data, setData] = useState([]);
  const [department, setDepartment] = useState('');
  const [status, setStatus] = useState('');
  const [client, setClient] = useState('');
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [searchWord, setSearchWord] = useState('');
  const dispatch = useDispatch();

  const { paymentData, isLoading, paymentfilterData } = useSelector((state) => state.payment); // Replace 'data' with your reducer name
  const { departments, clients, statuses } = paymentfilterData;

  useEffect(() => {
    const rangeDate = {
      dateStart: startDate,
      dateEnd: endDate
    };
    dispatch(
      PaymentAction.getAll(
        paginationModel,
        sortInfo,
        department,
        client,
        status,
        searchWord,
        rangeDate
      )
    );
  }, [
    dispatch,
    paginationModel,
    sortInfo,
    department,
    client,
    status,
    startDate,
    endDate,
    searchWord
  ]);
  useEffect(() => {
    dispatch(PaymentAction.getPaymentFilter());
  }, [dispatch]);

  useEffect(() => {
    if (paymentData) {
      if (paymentData.data) {
        setData(paymentData.data);
      } else {
        setData([]);
      }
      setRowCountState((prevRowCountState) =>
        paymentData.total !== undefined ? paymentData.total : prevRowCountState
      );
    }
  }, [paymentData]);

  const handleRangePicker = (date) => {
    if (!date || date.length !== 2 || date[1] === null) {
      return;
    }
    const formatDate = (newdate) => {
      return dateFormat(newdate, 'yyyy-mm-dd');
    };
    setDateRange(date.map(formatDate));
  };

  const columns = [
    {
      field: 'unique_id',
      headerName: '',
      sortable: false,
      align: 'left',
      // flex: 0.3,
      width: 70,
      renderCell: (params) => {
        if (params && params.value) {
          return <CopyInput id={params.value} />;
        }
        return null;
      }
    },
    {
      field: 'departments',
      headerName: 'Departments',
      sortable: false,
      // flex: 1,
      width: 225,
      renderCell: (params) => {
        if (params && params.value) {
          const result = params.value.filter((_, index) => index < 2);
          return (
            <>
              <Stack direction="row" spacing={1}>
                {result.map((item, index) => {
                  return (
                    <Tooltip title={item.name} arrow key={index}>
                      <Chip
                        sx={{
                          maxWidth: '60px !important',
                          p: 0.25,
                          pt: 0.5,
                          minWidth: 'auto',
                          height: 'auto',
                          '.MuiChip-label': {
                            fontSize: '13px',
                            letterSpacing: '0.5px',
                            opacity: 1
                          }
                        }}
                        label={item.name}
                        size="small"
                        color="primary"
                      />
                    </Tooltip>
                  );
                })}
              </Stack>
              {params.value.length > 3 ? (
                <Chip sx={{ minWidth: 50, ml: 1 }} label="..." size="small" color="primary" />
              ) : (
                ''
              )}
            </>
          );
        }
        return null;
      }
    },
    {
      field: 'name',
      headerName: 'Client Name',
      // flex: 1
      width: 170,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Typography component="p" variant="body1" noWrap>
              {params.value}
            </Typography>
          );
        }
        return null;
      }
    },
    {
      field: 'invoice_number',
      headerName: 'Invoice No',
      // flex: 0.65
      width: 150
    },
    {
      field: 'grand_total',
      headerName: 'Total',
      // flex: 0.75,
      width: 220,
      renderCell: (params) => {
        if ((params && params.value) || (params.row && params.row.symbol)) {
          return (
            <Typography component="p" variant="body1">
              {`${params.row.short_name} ${params.value}`}
            </Typography>
          );
        }
        return null;
      }
    },
    // {
    //   field: 'payment_method',
    //   headerName: 'Payment Method',
    //   flex: 1.25,
    //   renderCell: (params) => {
    //     if (params && params.value) {
    //       const result = params.value.map((item) => item.name).join(', ');
    //       const overflow = params.value.length > 2;
    //       return (
    //         <>
    //           <Typography component="p" variant="body1">
    //             {result}
    //           </Typography>
    //           {overflow && (
    //             <Typography component="p" variant="body1">
    //               , ...
    //             </Typography>
    //           )}
    //         </>
    //       );
    //     }
    //     return null;
    //   }
    // },
    {
      field: 'invoice_date',
      headerName: 'Request Date',
      // flex: 0.65,
      width: 150,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Typography component="p" variant="body1">
              {params.value}
            </Typography>
          );
        }
        return null;
      }
    },
    {
      field: '_updated_at',
      headerName: 'Payment Date & Time',
      // flex: 1,
      width: 220,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Typography component="p" variant="body1">
              {params.value}
            </Typography>
          );
        }
        return (
          <Typography component="p" variant="body1">
            -
          </Typography>
        );
      }
    },
    {
      field: 'status_name',
      headerName: 'Payment Status',
      // flex: 0.75,
      width: 150,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Chip label={params.value} color={params.value.toLowerCase().replace(/\s+/g, '')} />
          );
        }
        return null;
      }
    },
    useHasPermission(paymentRequest) && {
      field: 'actions',
      sortable: false,
      // type: 'actions',
      headerName: 'Actions',
      width: 220,
      // flex: 1,
      renderCell: (params) => {
        const { row } = params;
        const isDraft = row.status !== 5;
        // const isEditable = ![6, 11, 12, 16].includes(row.status);
        const isCancelable = row.status === 5;
        const isRemindable = row.status === 10 || row.status === 15;
        const isResendable = row.status === 10;
        if (row && row?._id) {
          return (
            <div className="MuiDataGrid-actionsCell">
              {isDraft && useHasPermission(paymentRequest, show) && (
                <IconButton
                  size="small"
                  className="actionBtn"
                  onClick={() => {
                    navigate(`/payment-request/view/${row._id}`);
                  }}
                  title="View"
                >
                  <i className="icon-view" />
                </IconButton>
              )}

              {!isDraft && useHasPermission(paymentRequest, update) && (
                <IconButton
                  size="small"
                  className="actionBtn"
                  onClick={() => {
                    navigate(`/payment-request/preview/${row._id}`);
                  }}
                  title="Send"
                >
                  <i className="icon-send" />
                </IconButton>
              )}

              {!isDraft && useHasPermission(paymentRequest, update) && (
                <IconButton
                  size="small"
                  className="actionBtn"
                  onClick={() => {
                    navigate(`/payment-request/edit/${row._id}`);
                  }}
                  title="Edit"
                >
                  <i className="icon-edit" />
                </IconButton>
              )}

              {isCancelable && useHasPermission(paymentRequest, destroy) && (
                <IconButton
                  size="small"
                  className="actionBtn"
                  onClick={() => {
                    setModalOpen(true);
                    seModalStatus({
                      itemID: row._id,
                      status: 'delete'
                    });
                  }}
                  title="Delete"
                >
                  <i className="icon-delete" />
                </IconButton>
              )}

              {isRemindable && useHasPermission(paymentRequest, update) && (
                <IconButton
                  size="small"
                  className="actionBtn"
                  onClick={() => {
                    setModalOpen(true);
                    seModalStatus({
                      itemID: row._id,
                      status: 'remind'
                    });
                  }}
                  title="Remind"
                >
                  <ScheduleSendIcon fontSize="inherit" />
                </IconButton>
              )}

              {isResendable && useHasPermission(paymentRequest, update) && (
                <IconButton
                  size="small"
                  className="actionBtn"
                  onClick={() => {
                    setModalOpen(true);
                    seModalStatus({
                      itemID: row._id,
                      status: 'resend'
                    });
                  }}
                  title="Resend"
                >
                  <LoopOutlined fontSize="inherit" />
                </IconButton>
              )}

              {useHasPermission(paymentRequest, store) && (
                <IconButton
                  size="small"
                  className="actionBtn"
                  onClick={() => {
                    setModalOpen(true);
                    seModalStatus({
                      itemID: row._id,
                      status: 'duplicate'
                    });
                  }}
                  title="Duplicate"
                >
                  <ContentCopyOutlined fontSize="inherit" />
                </IconButton>
              )}
            </div>
          );
        } else {
          console.error('No ID for row', params);
        }
        return null;
      }
    }

    // useHasPermission(paymentRequest) && {
    //   field: 'actions',
    //   type: 'actions',
    //   headerName: 'Actions',
    //   flex: 1,
    //   getActions: (params) => [
    //     params?.row?.status !== 5 ? ( // Draft
    //       paymentRequest && useHasPermission(paymentRequest, show) ? (
    //         <GridActionsCellItem
    //           icon={<i className="icon-view" />}
    //           className="actionBtn"
    //           title="View"
    //           label="View"
    //           onClick={() => {
    //             navigate(`/payment-request/view/${params.id}`);
    //           }}
    //         />
    //       ) : (
    //         <span />
    //       )
    //     ) : paymentRequest && useHasPermission(paymentRequest, update) ? (
    //       <GridActionsCellItem
    //         icon={<i className="icon-send" />}
    //         className="actionBtn"
    //         title="Send"
    //         label="Send"
    //         onClick={() => {
    //           navigate(`/payment-request/preview/${params.id}`);
    //         }}
    //       />
    //     ) : (<span />).params?.row?.status !== 6 &&
    //       params?.row?.status !== 11 &&
    //       params?.row?.status !== 12 &&
    //       params?.row?.status !== 16 ? (
    //       (paymentRequest && useHasPermission(paymentRequest, destroy) ? (
    //         <GridActionsCellItem
    //           icon={<i className="icon-edit" />}
    //           className="actionBtn"
    //           title="Edit"
    //           label="Edit"
    //           onClick={() => {
    //             navigate(`/payment-request/edit/${params.id}`);
    //           }}
    //         />
    //       ) : (
    //         <span />
    //       ),
    //       paymentRequest && useHasPermission(paymentRequest, destroy) ? (
    //         params?.row?.status === 5 ? (
    //           <GridActionsCellItem
    //             icon={<i className="icon-delete" />}
    //             className="actionBtn"
    //             title="Delete"
    //             label="Delete"
    //             onClick={() => {
    //               setModalOpen(true);
    //               seModalStatus({
    //                 itemID: params.id,
    //                 status: 'delete'
    //               });
    //               // setItemID(params.id);
    //             }}
    //           />
    //         ) : (
    //           <span />
    //         )
    //       ) : (
    //         <span />
    //       ))
    //     ) : (
    //       <span />
    //     ),
    //     params?.row?.status === 10 || params?.row?.status === 15 ? (
    //       <GridActionsCellItem
    //         icon={<ScheduleSendIcon />}
    //         className="actionBtn"
    //         title="Remind"
    //         label="Remind"
    //         onClick={() => {
    //           setModalOpen(true);
    //           seModalStatus({
    //             itemID: params.id,
    //             status: 'remind'
    //           });
    //         }}
    //       />
    //     ) : (
    //       <span />
    //     ),
    //     params?.row?.status === 10 ? (
    //       <GridActionsCellItem
    //         icon={<LoopOutlined fontSize="small" />}
    //         className="actionBtn"
    //         showInMenu
    //         title="Resend"
    //         label="Resend"
    //         onClick={() => {
    //           setModalOpen(true);
    //           seModalStatus({
    //             itemID: params.id,
    //             status: 'resend'
    //           });
    //         }}
    //       />
    //     ) : (
    //       <span />
    //     ),
    //     <GridActionsCellItem
    //       icon={<ContentCopyOutlined fontSize="small" />}
    //       showInMenu={
    //         params?.row?.status !== 6 &&
    //         params?.row?.status !== 11 &&
    //         params?.row?.status !== 12 &&
    //         params?.row?.status !== 16
    //       }
    //       className="actionBtn"
    //       title="Duplicate"
    //       label="Duplicate"
    //       onClick={() => {
    //         setModalOpen(true);
    //         seModalStatus({
    //           itemID: params.id,
    //           status: 'duplicate'
    //         });
    //       }}
    //     />
    //   ]
    // }
  ];

  const handleSortModelChange = React.useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0];
      const sortData = {
        sortField: field,
        sort
      };
      setSortInfo(sortData);
    }
    // else {
    //   dispatch(
    //     PaymentAction.getAll(paginationModel, sortInfo, department, client, status, searchWord)
    //   );
    // }
    // eslint-disable-next-line
  }, []);

  const onFilterChange = React.useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    const keywordData = filterModel.quickFilterValues[0];
    setSearchWord(keywordData);
    setPaginationModel({ page: 0, pageSize: 10 });
    // dispatch(PaymentAction.getAll(paginationModel, sortInfo, keyword));
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <div className="pageTitleWrap">
        <Typography className="" component="h2" variant="h2">
          Payment Request List
        </Typography>
      </div>
      <Card className="pageTitleWrap" sx={{ mb: 3 }}>
        <CardContent>
          <Grid container columnSpacing={3}>
            <Grid item md={3} lg={3}>
              <Autocomplete
                size="small"
                className="Department"
                options={departments ?? []}
                onChange={(e, newvalue) => {
                  if (newvalue && newvalue?._id) {
                    setDepartment(newvalue._id);
                  } else {
                    setDepartment('');
                  }
                  setPaginationModel({ page: 0, pageSize: 10 });
                }}
                // sx={{ width: '400px' }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option._id}>
                      {option.name}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Department"
                    placeholder="Search Department Name"
                    variant="outlined"
                    margin="none"
                  />
                )}
              />
            </Grid>
            <Grid item md={3} lg={3}>
              <Autocomplete
                className="filter"
                fullWidth
                size="small"
                options={clients ?? []}
                onChange={(e, newvalue) => {
                  if (newvalue && newvalue?._id) {
                    setClient(newvalue._id);
                  } else {
                    setClient('');
                  }
                  setPaginationModel({ page: 0, pageSize: 10 });
                }}
                sx={{ mt: 0 }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option._id}>
                      {option.name}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Client"
                    placeholder="Search Client Name"
                    variant="outlined"
                    margin="none"
                  />
                )}
              />
            </Grid>
            <Grid item md={3} lg={3}>
              <Box className="datepicker">
                <DatePicker
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(newValue) => {
                    setDateRange(newValue);
                    handleRangePicker(newValue);
                    setPaginationModel({ page: 0, pageSize: 10 });
                  }}
                  monthsShown={2}
                  isClearable
                  customInput={
                    <TextField
                      label="Date"
                      fullWidth
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              size="small"
                              aria-label="toggle password visibility"
                              edge="end"
                              disabled
                              // color="secondary"
                            >
                              <CalendarMonthIcon sx={{ color: '#fff' }} />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  }
                />
              </Box>
            </Grid>
            <Grid item md={3} lg={3}>
              <Autocomplete
                className="status"
                fullWidth
                size="small"
                options={statuses ?? []}
                onChange={(e, newvalue) => {
                  if (newvalue && newvalue?.id) {
                    setStatus(newvalue.id);
                  } else {
                    setStatus('');
                  }
                  setPaginationModel({ page: 0, pageSize: 10 });
                }}
                sx={{ mt: 0 }}
                getOptionLabel={(option) => option.status}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.id}>
                      {option.status}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Payment Status"
                    placeholder="Search Status"
                    variant="outlined"
                    margin="none"
                  />
                )}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
        <DataGrid
          rows={data}
          getRowId={(row) => row.unique_id}
          rowCount={rowCountState}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10
              }
            }
          }}
          autoHeight
          sx={{ minHeight: 650, '--DataGrid-overlayHeight': '50vh' }}
          disableColumnFilter
          rowHeight={50}
          slots={{
            toolbar: QuickSearchToolbar,
            loadingOverlay: LoadingSkeleton,
            noRowsOverlay: NoRowsOverlay
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          filterMode="server"
          onFilterModelChange={onFilterChange}
          disableRowSelectionOnClick
          loading={isLoading}
        />
      </Box>

      {/* {editOpen === true ? (
        <UserEdit openmodal={editOpen} modalStatus={modalStatus} onCloseModal={() => setEditOpen(false)} />
      ) : (
        ''
      )} */}
      {modalOpen === true ? (
        <ConfirmModal
          openmodal={modalOpen}
          modalstatus={modalStatus}
          onCloseModal={() => setModalOpen(false)}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
